import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import { connect } from "react-redux";

import ReactTable from "react-table";

import loaderIcon from "assets/img/loader.gif";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import IconButton from "@material-ui/core/IconButton";
import green from "@material-ui/core/colors/green";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";

// import VisibilityIcon from "@material-ui/icons/Visibility";

import DeleteModel from "components/Common/FevoModels/DeleteModel";
// import { getAllCategories$ } from "../../../redux/actions/category";

import TextField from "@material-ui/core/TextField";

import axios from "../../../config/axios";
import {
  // Switch,
  // FormControlLabel,
  // Select,
  // MenuItem,
  // InputLabel,
  FormControl,
  // Checkbox,
  // InputAdornment,
  // Input
} from "@material-ui/core";

import toastr from "toastr";
import { getAllStaff$ } from "../../../redux/actions/staff";

const formStyle = {
  minWidth: "100%",
  margin: "0 1.2rem 1.2rem 0"
};

class ManageStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
      staffDeletedIndex: null,
      staffTobeDeleted: null,
      showDeleteStaffModal: false,
      staffData: []
    };
  }

  componentDidMount() {
    this.props.handleGetStaffList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.staffListData !== prevProps.staffListData) {
      let staffData = [];
      if (prevProps.staffListData.data.length > 0) {
        prevProps.staffListData.data.map(staff => {
          staffData.push(staff);
        });
      }
      this.setState({ staffData });
    }
  }

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green
      }
    });
    let column = [
      {
        Header: "Staff Name",
        accessor: "name"
      },
      {
        Header: "Email",
        accessor: "email"
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: staff => {
          return (
            <div className="actions-center">
              <Tooltip title="View Staff">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.props.history.push("/admin/managestaff/viewstaff", {
                      action: "view",
                      staff: staff.original
                    });
                  }}
                >
                  <Icon>visibility_icon</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit Staff">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.props.history.push("/admin/managestaff/editstaff", {
                      action: "edit",
                      staff: staff.original
                    });
                  }}
                >
                  <Icon>edit_icon</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Staff">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.handleStaffDeleteChange(staff.original, staff.index);
                  }}
                >
                  <Icon>delete_icon</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        }
      }
    ];
    return column;
  };

  handleStaffDeleteChange = (staffTobeDeleted, staffDeletedIndex) => {
    this.setState({
      staffDeletedIndex,
      staffTobeDeleted,
      showDeleteStaffModal: true
    });
  };

  deleteStaff = (staff, index) => {
    axios
      .delete(`staff/users/${staff.id}`)
      .then(res => {
        if (res.status === 200) {
          toastr.success("Staff Deleted Successfully!");
          this.handleDeleteModal();
          this.props.handleGetStaffList();
        }
      })
      .catch(error => toastr.error("Something wrong happened!"));
  };

  handleDeleteModal = () => {
    this.setState(({ showDeleteStaffModal }) => ({
      showDeleteStaffModal: !showDeleteStaffModal,
      staffDeletedIndex: null,
      staffTobeDeleted: null
    }));
  };

  pageChange=()=>{
    let node = document.getElementById("event_main_page");
    if (node){
      node.scrollTop = 0
    }
  }
  render() {
    const { showDeleteStaffModal, search_staff, staffData } = this.state;
    const { staffListData, classes } = this.props;
    const { loading, data } = staffListData;
    return (
      <div>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} />
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody>
                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <TextField
                        id="standard-search"
                        label="Search Staff by name"
                        name="search_staff"
                        type="search"
                        fullWidth
                        value={search_staff}
                        onChange={event => {
                          const { value } = event.target;
                          this.setState(
                            {
                              staffData: data
                            },
                            () => {
                              const newList = this.state.staffData.filter(
                                item =>
                                  item.name
                                    .toLowerCase()
                                    .includes(value.toLowerCase())
                              );
                              this.setState({
                                staffData: newList,
                                search_staff: value.toLowerCase()
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                    </FormControl>
                    <ReactTable
                      data={staffData}
                      loading={loading}
                      columns={this.getUserTableColumn()}
                      defaultPageSize={25}
                      pageSizeOptions={[25, 50, 100]}
                      showPaginationBottom={true}
                      minRows={0}
                      noDataText="No staff found"
                      onPageChange={this.pageChange}
                      onPageSizeChange={this.pageChange}
                      getTrProps={(state, rowInfo, column, instance) => {
                        return {
                          onClick: (e, handleOriginal) => {
                            if (rowInfo) {
                              // this.editCategoryFunc(rowInfo.original);
                            }
                          },
                          style: {
                            // textAlign: "center",
                            cursor: "pointer"
                          }
                        };
                      }}
                      getTheadThProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            marginBottom: "13px"
                          }
                        };
                      }}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            <DeleteModel
              showModel={showDeleteStaffModal}
              title={"Are you sure you want to delete this staff?"}
              onCancel={this.handleDeleteModal}
              onOk={() => {
                let { staffDeletedIndex, staffTobeDeleted } = this.state;
                this.deleteStaff(staffTobeDeleted, staffDeletedIndex);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    staffListData: state.staff
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetStaffList: () => dispatch(getAllStaff$.trigger())
  };
};

const ManageStaffListComponent = withStyles(extendedTablesStyle)(ManageStaff);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageStaffListComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/StaffManagement/index.js